/**
 * Production site URL for canonical, OG URLs, and sitemap alignment.
 * Optional: set REACT_APP_SITE_URL in .env if the live URL differs (e.g. https://www.chooserightcareer.in).
 */
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://chooserightcareer.in"
).replace(/\/$/, "");
